(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["video"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    console.log('Simple video controls init');
    
    const wrappers = document.querySelectorAll('.video-wrapper-custom');
    
    wrappers.forEach(function(wrapper) {
      const video = wrapper.querySelector('video');
      const unmuteBtn = wrapper.querySelector('.volume-btn-unmute');
      const muteBtn = wrapper.querySelector('.volume-btn-mute');
      
      if (!video || !unmuteBtn || !muteBtn) {
        console.log('Missing elements');
        return;
      }
      
      console.log('Video setup:', {
        autoplay: video.autoplay,
        muted: video.muted,
        loop: video.loop,
        paused: video.paused
      });
      
      // Funzioni semplici
      function updateButtons(isMuted) {
        if (isMuted) {
          unmuteBtn.style.display = 'flex';
          muteBtn.style.display = 'none';
        } else {
          unmuteBtn.style.display = 'none';
          muteBtn.style.display = 'flex';
        }
      }
      
      function handleUnmute(e) {
        e.preventDefault();
        video.muted = false;
        updateButtons(false);
        console.log('Unmuted');
      }
      
      function handleMute(e) {
        e.preventDefault();
        video.muted = true;
        updateButtons(true);
        console.log('Muted');
      }
      
      // Event listeners semplici
      unmuteBtn.addEventListener('click', handleUnmute);
      muteBtn.addEventListener('click', handleMute);
      
      // Touch support
      unmuteBtn.addEventListener('touchend', function(e) {
        e.preventDefault();
        handleUnmute(e);
      });
      
      muteBtn.addEventListener('touchend', function(e) {
        e.preventDefault();
        handleMute(e);
      });
      
      // Sync con cambiamenti video
      video.addEventListener('volumechange', function() {
        updateButtons(video.muted);
      });
      
      // Stato iniziale
      updateButtons(video.muted);
      
      console.log('Video controls ready');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
